import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";
import { ArrowRightIcon } from "lucide-react";

import { groupCoverImage } from "simplydo/core/images";
import { initUseQuery } from "simplydo/core/query";
import { useTheme } from "simplydo/react/theme";
import { ButtonLink } from "simplydo/react/ui/button";
import { Card, CardContent } from "simplydo/react/ui/card";
import { H3, H4, Subheader } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Image } from "simplydo/react/ui/image";

import api from "api";

import HomeBlock from "./HomeBlock";

const GroupsBlock = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const groupsQuery = useQuery(initUseQuery(api.users.dashboard, []));

  if (!groupsQuery.data?.groups?.length) return null;

  return (
    <HomeBlock>
      <CardContent>
        <H3>
          {t("users.home.groups.engage")}
          <Subheader>{t("users.home.groups.info")}</Subheader>
        </H3>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 12,
            overflowX: "auto",
            width: 0,
            minWidth: "100%",
            padding: 12,
          }}
        >
          {groupsQuery.data?.groups.map((group) => {
            const unseenCount = group.unseenCommentCount ?? 0;
            let activityLabel: string | null = null;
            if (unseenCount === 1 && group.latestUnseenDiscussionName) {
              activityLabel = `New message on ${group.latestUnseenDiscussionName}`;
            } else if (unseenCount === 1) {
              activityLabel = "1 new message";
            } else if (unseenCount > 1) {
              activityLabel = `${unseenCount} new messages`;
            }

            return (
              <div key={group._id} style={{ width: 200, display: "flex" }}>
                <Card style={{ margin: 0, flex: 1 }} elevation="small">
                  <Image
                    src={groupCoverImage(group)}
                    height={100}
                    style={{
                      objectFit: "cover",
                      backgroundColor: theme.colors.primary.soft,
                    }}
                  />
                  <CardContent>
                    <H4>
                      {group.name}
                      {activityLabel ? (
                        <Subheader>{activityLabel}</Subheader>
                      ) : null}
                    </H4>
                  </CardContent>
                  <CardContent
                    style={{
                      display: "flex",
                      flex: 0,
                      justifyContent: "flex-end",
                    }}
                  >
                    <ButtonLink
                      color="primary"
                      variant="outline"
                      style={{ fontWeight: "bold" }}
                      size="small"
                      to={`/groups/${group._id}`}
                    >
                      {t("generic.viewType", { entity: t("generic.group") })}
                    </ButtonLink>
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </div>
      </CardContent>
      <CardContent color="primary" textAlign="right" style={{ flexGrow: 0 }}>
        <ButtonLink color="primary" variant="ghost" size="small" to="/groups">
          {t("users.home.groups.view.all")}
          <Icon icon={ArrowRightIcon} />
        </ButtonLink>
      </CardContent>
    </HomeBlock>
  );
};

export default GroupsBlock;
